import GraphAxisDisplayOptions from "./GraphAxisDisplayOptions";

class GraphAxesDisplayOptions {
    constructor(xAxis, yAxis) {
        this.xAxis = xAxis || new GraphAxisDisplayOptions();
        this.yAxis = yAxis || new GraphAxisDisplayOptions();
    };
}
export default GraphAxesDisplayOptions;